import { useQuery } from '@tanstack/react-query';
import verifyToken from './verifyToken';
import { retrieveRefreshToken, retrieveToken } from '../../../../utils/token';

export default function useVerifyToken() {
  const token = retrieveToken();
  const refreshToken = retrieveRefreshToken();

  return useQuery({
    queryKey: ['use-verify-token'],
    queryFn: () => verifyToken(),
    enabled: token !== undefined || refreshToken !== null,
  });
}
